import { ActionMetaInfo, AppContext } from 'mini-app-context';
import { executeDiagnosticsTask } from 'mini-diagnostics/lib/utils/executeDiagnosticsTask';
import { getDataLogger } from 'telemetry';
import { logDiagnostics } from 'mini-diagnostic-store/lib/actions/logDiagnostics';

/**
 * Listener to log the app signals
 */
export function logListener(metaInfo: ActionMetaInfo, ctx: AppContext) {
    const logger = getDataLogger();
    const { name, actionSource, customData, options } = metaInfo;

    /**
     * WI : 103943 : Revamp the logListener logic to capture only required signals for logging.
     */
    if (options?.signalType) {
        return;
    }

    logger(name, { ...customData, cId: ctx.correlationId }, { actionSource, ...options });

    // Log for diagnostics
    executeDiagnosticsTask(() => logDiagnostics({ name, customData, cId: ctx.correlationId }));
}
